export function cleanDescription(description: string): string {
  const replacements: { [key: string]: string } = {
    '12 NOON': 'NOON',
    'NOON 1:3-PM': 'NOON TO 1:30PM',
    '8AM 11AM': '8AM TO 11AM',
    '11:30AM-1 M': '11:30AM-1PM',
    'NP PARKING': 'NO PARKING',
    'BROON': 'BROOM',
    'BRROM': 'BROOM',
    'SANI-TATION': 'SANITATION'
  };

  let cleaned = description;
  Object.entries(replacements).forEach(([from, to]) => {
    cleaned = cleaned.replace(new RegExp(from, 'g'), to);
  });
  return cleaned;
}